export default __webpack_public_path__ + "static/media/closed_eye_icon.c73938b3.svg";